// src/context/store.js
import { configureStore } from "@reduxjs/toolkit";
import { api } from "./api";
// apiSlice import qilish shart emas, u allaqachon api ga inject qilingan

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    // auth: authReducer, va hokazo...
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
